export default {
  'customerDiscountType.percentage': 'Percentage',
  'customerDiscountType.fixedAmount': 'Fixed amount',
  'customerDiscountFrequencyType.oneTime': 'One period',
  'customerDiscountFrequencyType.recurring': 'Recurring',
  'customerDiscountAssignmentStatus.scheduled': 'Scheduled',
  'customerDiscountAssignmentStatus.active': 'Active',
  'customerDiscountAssignmentStatus.exhausted': 'Exhausted',
  'customerDiscountAssignmentStatus.ended': 'Ended',
  'customerDiscountAssignmentStatus.scheduled.hint': 'Starts in the future. Occupies the customer.',
  'customerDiscountAssignmentStatus.active.hint':
    'May apply to the next charge. Occupies the customer.',
  'customerDiscountAssignmentStatus.exhausted.hint': 'The period count was reached. History only.',
  'customerDiscountAssignmentStatus.ended.hint':
    'An administrator ended it, or the stop date passed. History only.',
  'customerDiscounts.filters.includeInactive': 'Include deactivated templates',
  'customerDiscounts.fields.discountType': 'Type',
  'customerDiscounts.fields.discountValue': 'Value',
  'customerDiscounts.fields.frequencyType': 'Frequency',
  'customerDiscounts.fields.durationPeriods': 'Periods',
  'customerDiscounts.fields.durationIndefinite': 'Indefinite',
  'customerDiscounts.fields.durationHint': 'Empty: a recurring discount has no period limit.',
  'customerDiscounts.fields.effectiveFrom': 'Available from',
  'customerDiscounts.fields.effectiveTo': 'Available until',
  'customerDiscounts.fields.catalogEffectiveFrom': 'Can be assigned from',
  'customerDiscounts.fields.catalogEffectiveTo': 'Can be assigned until',
  'customerDiscounts.fields.isActive': 'Status',
  'customerDiscounts.fields.subscription': 'Subscription',
  'customerDiscounts.fields.agreement': 'Active template',
  'customerDiscounts.fields.assignmentFrom': 'Applies from',
  'customerDiscounts.fields.assignmentTo': 'Applies until',
  'customerDiscounts.fields.appliedPeriodCount': 'Consumed periods',
  'customerDiscounts.fields.baseNetAmount': 'Base',
  'customerDiscounts.fields.discountAmount': 'Discount',
  'customerDiscounts.fields.netAmount': 'Net',
  'customerDiscounts.fields.mrrAmount': 'MRR',
  'customerDiscounts.status.activeTemplate': 'Active',
  'customerDiscounts.status.inactiveTemplate': 'Deactivated',
  'customerDiscounts.actions.assign': 'Assign discount',
  'customerDiscounts.actions.deactivate': 'Deactivate',
  'customerDiscounts.actions.end': 'End',
  'customerDiscounts.deactivate.title': 'Deactivate template',
  'customerDiscounts.deactivate.message':
    '“{name}” will not accept new assignments. Assignments already made stay as they are.',
  'customerDiscounts.assign.title': 'Assign discount',
  'customerDiscounts.assign.message':
    'The contractual price stays the same. The discount applies to the next period that has not been charged yet.',
  'customerDiscounts.assign.blocked':
    'This subscription already has an open discount. End it before assigning another.',
  'customerDiscounts.end.title': 'End discount',
  'customerDiscounts.end.message':
    'The assignment stops occupying the customer. A Stripe checkout already created with this price does not change.',
  'customerDiscounts.section.title': 'Customer discount',
  'customerDiscounts.section.open': 'A discount currently occupies this customer.',
  'customerDiscounts.section.empty': 'This customer has no open discount.',
  'customerDiscounts.section.nextCharge': 'Next charge, before tax',
  'customerDiscounts.section.history': 'Discount history',
  'customerDiscounts.section.history.description':
    'Discount assignments for this subscription, including those that already ended.',
  'customerDiscounts.section.payments': 'Confirmed payments',
  'customerDiscounts.section.payments.description':
    'Confirmed payments. The discount stays frozen on each charge and is not recalculated.',
  'customerDiscounts.payments.empty': 'There are no confirmed payments.',
  'customerDiscounts.payments.noDiscount': 'This charge had no discount.',
};
